import React, { useEffect, useState } from "react";
import PopupHandler from "./PopupHandler";
import graph from "./graph";

import { useSelector } from "react-redux";
import { useLazyQuery } from "@apollo/client";
import { isEmptyObject } from "helpers/formatObject";

export default function MainModel(props) {
  const { initFilter, isPopup = false } = props;
  const init = { ...initFilter };

  const [startFetch, setStartFetch] = useState(!isPopup);
  const [flag, setFlag] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(2);
  const [total, setTotal] = useState(0);
  const [result, setResult] = useState([]);
  const [filter, setFilter] = useState(init);
  const [selectable, setSelectable] = useState(false);
  const { userToken } = useSelector((state) => state.auth);

  const clearFilter = () => setFilter(init);

  const handleSetFilter = (filter) => {
    setPage(1);
    setResult([]);
    setFilter((prev) => ({ ...prev, ...filter }));
  };

  const [getData, { loading }] = useLazyQuery(graph.list.query, {
    context: {
      serviceName: graph.list.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const refresh = () => {
    setPage(1);
    setResult([]);
    setFlag(!flag);
  };

  const handleData = async () => {
    try {
      const { data, error } = await getData({
        variables: {
          ...filter,
          page,
          limit,
        },
      });
      if (!isEmptyObject(data) && !error) {
        const { task, request } = data;
        // setTotal(Math.max(task?.total, request?.total));
        setTotal(Math.max(task?.last_page, request?.last_page));
        setResult(
          task?.data
            .concat(request?.data.map((x) => ({ ...x, node: "request" })))
            .sort((a, b) => new Date(b.request_date) - new Date(a.request_date))
        );
      }
    } catch (error) {}
  };

  useEffect(() => {
    startFetch && handleData();
  }, [startFetch, page, filter, flag]);

  useEffect(() => {
    initFilter && setFilter(initFilter);
  }, [initFilter]);

  return (
    <PopupHandler
      {...props}
      page={page}
      limit={limit}
      total={total}
      result={result}
      filter={filter}
      loading={loading}
      refetch={refresh}
      setPage={setPage}
      setLimit={setLimit}
      isPopup={isPopup}
      selectable={selectable}
      clearFilter={clearFilter}
      setFilter={handleSetFilter}
      setStartFetch={setStartFetch}
      setSelectable={setSelectable}
    />
  );
}
